import { Modal, Button, Box, SpaceBetween } from '@cloudscape-design/components';

interface WarningModalProps {
  visible: boolean;
  title: string;
  message: string;
  onOk: () => void;
  onCancel: () => void;
}

const WarningModal = ({ visible, title, message, onOk, onCancel }: WarningModalProps) => {
  return (
    <Modal
      visible={visible}
      onDismiss={onCancel}
      header={title}
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="link" onClick={onCancel}>
              Cancel
            </Button>
            <Button variant="primary" onClick={onOk}>
              Ok
            </Button>
          </SpaceBetween>
        </Box>
      }
    >
      {message}
    </Modal>
  );
};

export default WarningModal;
